/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Recover_TitleInputs */



/**
* | output |
* | --- |
* | "Get a new link" |
*
* @param {Login_Recover_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_recover_title = /** @type {((inputs?: Login_Recover_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Recover_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Obtenez un nouveau lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Obtenga un enlace nuevo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Obtenha um novo link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ottieni un nuovo link")
	return /** @type {LocalizedString} */ ("Get a new link")
});